// Arcana gallery helpers on top of Dawn's <media-gallery> (assets/media-gallery.js) and <product-modal>:
// - desktop vertical thumbnail rail: keep the active thumbnail in view (Dawn only scrolls sideways)
// - ← / → keys switch photos while focus is inside the gallery
// - phones: "3 / 58" counter in the full-screen photo viewer (a swipe strip, see arcana-gallery.css)
// Dawn re-runs section scripts when a quick-add modal opens, so everything here runs once per page
// and each element is set up at most once.
if (!window.arcanaGalleryInit) {
  window.arcanaGalleryInit = true;

  customElements.whenDefined('media-gallery').then(() => {
    const MediaGallery = customElements.get('media-gallery');
    const desktop = window.matchMedia('(min-width: 990px)');
    const original = MediaGallery.prototype.setActiveThumbnail;

    MediaGallery.prototype.setActiveThumbnail = function (thumbnail) {
      const rail = desktop.matches && this.dataset.desktopLayout === 'thumbnail_slider';
      if (!rail || !this.elements.thumbnails || !thumbnail) return original.call(this, thumbnail);

      this.elements.thumbnails.querySelectorAll('button').forEach((button) => button.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      const list = thumbnail.parentElement;
      const top = thumbnail.offsetTop - list.offsetTop;
      if (top < list.scrollTop || top + thumbnail.offsetHeight > list.scrollTop + list.clientHeight) {
        list.scrollTo({ top: top - list.clientHeight / 2 + thumbnail.offsetHeight / 2, behavior: 'smooth' });
      }
    };

    const setUpKeys = (gallery) => {
      if (gallery.dataset.arcanaKeys || gallery.closest('quick-add-modal')) return;
      gallery.dataset.arcanaKeys = 'true';
      gallery.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (event.target.closest('input, select, textarea, model-viewer, video')) return;
        const thumbs = [...gallery.querySelectorAll('[id^="GalleryThumbnails"] [data-target]')].filter(
          (item) => item.offsetParent !== null
        );
        if (thumbs.length < 2) return;
        const current = thumbs.findIndex((item) => item.querySelector('button[aria-current]'));
        const step = event.key === 'ArrowRight' ? 1 : -1;
        const next = thumbs[(Math.max(current, 0) + step + thumbs.length) % thumbs.length];
        event.preventDefault();
        next.querySelector('button').click();
        next.querySelector('button').focus({ preventScroll: true });
      });
    };
    document.querySelectorAll('media-gallery').forEach(setUpKeys);
  });

  // Full-screen viewer counter (phones)
  const setUpModal = (modal) => {
    if (modal.dataset.arcanaCounter) return;
    const content = modal.querySelector('.product-media-modal__content');
    if (!content) return;
    modal.dataset.arcanaCounter = 'true';
    const counter = document.createElement('div');
    counter.className = 'arcana-modal-counter';
    counter.setAttribute('aria-hidden', 'true');
    content.after(counter);

    const items = () => [...content.children].filter((el) => el.offsetParent !== null);
    const update = () => {
      const list = items();
      if (list.length < 2) return (counter.hidden = true);
      counter.hidden = false;
      const index = Math.round(content.scrollLeft / Math.max(content.clientWidth, 1));
      counter.textContent = `${Math.min(index + 1, list.length)} / ${list.length}`;
    };
    content.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    const phone = window.matchMedia('(max-width: 749px)');
    new MutationObserver(() => {
      // Dawn's showActiveMedia() resets scrollLeft after scrolling the tapped photo into view;
      // in the swipe strip that lands on photo 1, so jump back to the tapped (.active) photo.
      if (modal.hasAttribute('open') && phone.matches) {
        const active = content.querySelector(':scope > .active');
        if (active) content.scrollLeft = active.offsetLeft - content.offsetLeft;
      }
      requestAnimationFrame(update);
    }).observe(modal, {
      attributes: true,
      attributeFilter: ['open'],
    });
  };
  const initModals = () => document.querySelectorAll('product-modal').forEach(setUpModal);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initModals);
  else initModals();
}
